// TODO: migrate from legacy CI tooling: resolve ts-* and/or eslint-* directives below (including inline comments)
/* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment, react-hooks/exhaustive-deps, react-hooks/set-state-in-effect */

import React, { useEffect, useMemo, useState } from "react";
import { Select } from "semantic-ui-react";
import { useViewerDispatch } from "../StateManagement";
import { useModuleNavigation } from "../../../../../hooks/useModuleNavigation";
import { useQuery } from "@tanstack/react-query";
import { experimentalDesignsForMFAQueryOptions } from "../../../../../apis/factorApi";
import { useUserAuth } from "../../../../../hooks/useUserAuth";
import { useAuth0 } from "../../../../../auth/auth0";

export const ExperimentalDesignDropdown = () => {
	const { updateExperimentalDesign, updateTreatmentNames } = useViewerDispatch();

	const moduleNavigation = useModuleNavigation();
	const userAuth = useUserAuth();
	const { getTokenSilently } = useAuth0();

	const [selectedDesign, setSelectedDesign] = useState<string>();
	// const [experimentalDesigns, setExperimentalDesigns] = useState<any[]>([]);

	const experimentalDesignsQueryOpts = experimentalDesignsForMFAQueryOptions(
		moduleNavigation.trialId,
		userAuth.currentClientId!,
		getTokenSilently,
	);

	const { data: dropdownInfo, isFetching } = useQuery(experimentalDesignsQueryOpts);

	const experimentalDesignOptions = useMemo(() => {
		if (dropdownInfo.length > 0) {
			const opts: { key: string; text: string; value: string }[] = [];
			return opts.concat(dropdownInfo.map((ed, i) => ({ key: ed.id, text: `EXP${i} - ${ed.name}`, value: ed.id })));
		} else {
			return [];
		}
	}, [dropdownInfo]);

	useEffect(() => {
		if (dropdownInfo.length > 0) {
			setSelectedDesign(dropdownInfo.find((ed) => ed.default)?.id ?? dropdownInfo[0].id);
		}
	}, [dropdownInfo]);

	useEffect(() => {
		if (selectedDesign && dropdownInfo.length > 0) {
			if (selectedDesign === "exp0") {
				updateExperimentalDesign([]);
				updateTreatmentNames([]);
			} else {
				const exp = dropdownInfo.find((ed) => ed.id === selectedDesign)!;
				updateExperimentalDesign(exp.design);
				updateTreatmentNames(exp.treatmentNames);
			}
		}
	}, [selectedDesign, dropdownInfo]);

	return (
		<>
			<span style={{ width: 100, fontSize: "1em", lineHeight: 1.2, textAlign: "right" }}>
				Experimental
				<br />
				Design
			</span>
			<Select
				compact
				options={experimentalDesignOptions}
				loading={isFetching}
				// defaultValue={"exp1"}
				value={selectedDesign}
				onChange={(_, { value }) => {
					setSelectedDesign(value as string);
				}}
			/>
		</>
	);
};
